import React, { ReactElement } from "react";
import { Divider, Dropdown, Form, Header, Icon, Segment } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import { PermitAssignment } from "../models/PermitAssignment";
import { RegisterAssignment } from "../models/RegisterAssignment";
import { PermitTypeOrgRole } from "../models/PermitTypeOrgRole";
import ErrorsView from "./ErrorsView";

export interface FormData {
  permitAssignments: PermitAssignment[];
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  registerAssignments?: RegisterAssignment[];
  onChange: (formData: FormData) => void;
  showRequiredAsterisk?: boolean;
  permitTypeRoles?: PermitTypeOrgRole[];
}

function PermitTeamForm({
  formData,
  formErrors,
  errors,
  registerAssignments,
  onChange,
  showRequiredAsterisk = true,
  permitTypeRoles,
}: Props): ReactElement {
  const handleChange = (e: any, { name, value }: any) => {
    const newValues = [...formData.permitAssignments];
    const assignmentIndex = formData.permitAssignments.findIndex((a) => a.orgRole.id === name);
    const selectedUser = registerAssignments?.find((a) => a.orgUser.id === value)?.orgUser;

    newValues[assignmentIndex] = { ...newValues[assignmentIndex], orgUser: selectedUser ?? null };

    onChange({ ...formData, permitAssignments: newValues });
  };

  const isMandatory = (assignment: PermitAssignment) => {
    const ptr = permitTypeRoles?.find((r) => r.orgRole.id === assignment.orgRole.id);
    return (
      (ptr?.settings ?? ptr?.orgRole.permitRoleSettings)?.mandatoryOnSubmission ??
      assignment.orgRole.permitRoleSettings.mandatoryOnSubmission
    );
  };

  return (
    <>
      <Segment basic vertical>
        <Header as="h3">
          <Icon name="users" />
          <Header.Content> Permit team</Header.Content>
        </Header>
        <Divider />
        <Form>
          {formData.permitAssignments.map((assignment) => (
            <Form.Field
              required={showRequiredAsterisk && isMandatory(assignment)}
              error={formErrors[`permitAssignment_${assignment.orgRole.id}`]}
              control={Dropdown}
              clearable
              name={assignment.orgRole.id}
              fluid
              label={assignment.orgRole.displayName}
              value={assignment.orgUser?.id}
              options={registerAssignments
                ?.filter((a) => a.permitTypeOrgRole.orgRole.id === assignment.orgRole.id)
                .filter((a, i, arr) => arr.findIndex((b) => b.orgUser.id === a.orgUser.id) === i)
                .map((a) => ({
                  key: a.orgUser.id,
                  text: a.orgUser.user.displayName,
                  value: a.orgUser.id,
                }))}
              onChange={handleChange}
              selection
              search
            />
          ))}
        </Form>
        <ErrorsView errors={errors} />
      </Segment>
    </>
  );
}

export default PermitTeamForm;
